import React, { Fragment, useEffect, useState, useRef } from 'react';
import {
  Row,
  CardBody,
  Card,
  Button,
  Label,
  Table,
  ButtonGroup,
  CustomInput,
  Input,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Separator,
  Colxx,
} from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Languages from '../../../../../../data/languages';
import { InputStlye, SelectStyle } from '../../style/DigitalAssistantStyle';
import Angus from '../../../../../../assets/audio/angus_docs.wav';
import Arcas from '../../../../../../assets/audio/arcas_docs.mp3';
import Asteria from '../../../../../../assets/audio/asteria_docs.wav';
import Athena from '../../../../../../assets/audio/athena_docs.wav';
import Amalthea from '../../../../../../assets/audio/amalthea_docs.wav';
import Helios from '../../../../../../assets/audio/helios_docs.wav';
import Hera from '../../../../../../assets/audio/hera_docs.wav';
import Orion from '../../../../../../assets/audio/orion_doc.mp3';
import Orpheus from '../../../../../../assets/audio/orpheus_docs.wav';
import Perseus from '../../../../../../assets/audio/perseus_docs.wav';
import Stella from '../../../../../../assets/audio/stella_docs.wav';
import Zeus from '../../../../../../assets/audio/zeus_docs.wav';
import Luna from '../../../../../../assets/audio/luna_docs.wav';
import Odysseus from '../../../../../../assets/audio/odysseus_docs.wav';
import Thalia from '../../../../../../assets/audio/thalia_docs.wav';
import Apollo from '../../../../../../assets/audio/apollo_docs.wav';
import Aurora from '../../../../../../assets/audio/aurora_docs.wav';
import Atlas from '../../../../../../assets/audio/atlas_docs.wav';
import Callista from '../../../../../../assets/audio/callista_docs.wav';
import Cordelia from '../../../../../../assets/audio/cordelia_docs.wav';
import Cora from '../../../../../../assets/audio/cora_docs.wav';
import Draco from '../../../../../../assets/audio/draco_docs.wav';
import Delia from '../../../../../../assets/audio/delia_docs.wav';
import Electra from '../../../../../../assets/audio/electra_docs.wav';
import Harmonia from '../../../../../../assets/audio/harmonia_docs.wav';
import Helena from '../../../../../../assets/audio/helena_docs.wav';
import Hermes from '../../../../../../assets/audio/hermes_docs.wav';
import Hyperion from '../../../../../../assets/audio/hyperion_docs.wav';
import Iris from '../../../../../../assets/audio/iris_docs.wav';
import Janus from '../../../../../../assets/audio/janus_docs.wav';
import Juno from '../../../../../../assets/audio/juno_docs.wav';
import Jupiter from '../../../../../../assets/audio/jupiter_docs.wav';
import Mars from '../../../../../../assets/audio/mars_docs.wav';
import Minerva from '../../../../../../assets/audio/minerva_docs.wav';
import Neptune from '../../../../../../assets/audio/neptune_docs.wav';
import Ophelia from '../../../../../../assets/audio/ophelia_docs.wav';
import Pandora from '../../../../../../assets/audio/pandora_docs.wav';
import Phoebe from '../../../../../../assets/audio/phoebe_docs.wav';
import Pluto from '../../../../../../assets/audio/pluto_docs.wav';
import Saturn from '../../../../../../assets/audio/saturn_docs.wav';
import Selene from '../../../../../../assets/audio/selene_docs.wav';
import Theia from '../../../../../../assets/audio/theia_docs.wav';
import Vesta from '../../../../../../assets/audio/vesta_docs.wav';
///New
import adriano_italian from '../../../../../../assets/audio/adriano_italian.mp3';
import amy_english_british from '../../../../../../assets/audio/amy_english_british.mp3';
import aria_english_newzeland from '../../../../../../assets/audio/aria_english_newzeland.mp3';
import arlet_catalan from '../../../../../../assets/audio/arlet_catalan.mp3';
import arthur_english_british from '../../../../../../assets/audio/arthur_english_british.mp3';
import ayanda_english_south_africa from '../../../../../../assets/audio/ayanda_english_south_africa.mp3';
import bianca_italian from '../../../../../../assets/audio/bianca_italian.mp3';
import brian_english_british from '../../../../../../assets/audio/brian_english_british.mp3';
import zayd_arabic_gulf from '../../../../../../assets/audio/zayd_arabic_gulf.mp3';
import zeina_arabic from '../../../../../../assets/audio/zeina_arabic.mp3';
import zhiyu_chinese_mandarian from '../../../../../../assets/audio/zhiyu_chinese_mandarian.mp3';

import vitoria_portegues_brazillain from '../../../../../../assets/audio/vitoria_portegues_brazillain.mp3';
import vicki_german from '../../../../../../assets/audio/vicki_german.mp3';
import thiago_portegues_brazillain from '../../../../../../assets/audio/thiago_portegues_brazillain.mp3';
import takumi_japneese from '../../../../../../assets/audio/takumi_japneese.mp3';
import sofie_dutch from '../../../../../../assets/audio/sofie_dutch.mp3';
import sergio_spanish_castilian from '../../../../../../assets/audio/sergio_spanish_castilian.mp3';
import seoyeon_korean from '../../../../../../assets/audio/seoyeon_korean.mp3';
import remi_french from '../../../../../../assets/audio/remi_french.mp3';
import olivia_english_aus from '../../../../../../assets/audio/olivia_english_aus.mp3';
import ola_polish from '../../../../../../assets/audio/ola_polish.mp3';
import niamh_english_irish from '../../../../../../assets/audio/niamh_english_irish.mp3';

import lucia_spanish_castilian from '../../../../../../assets/audio/lucia_spanish_castilian.mp3';
import lisa_dutch_beligan from '../../../../../../assets/audio/lisa_dutch_beligan.mp3';
import lea_french from '../../../../../../assets/audio/lea_french.mp3';
import laura_danish from '../../../../../../assets/audio/laura_danish.mp3';
import kajal_english_indian from '../../../../../../assets/audio/kajal_english_indian.mp3';
import jitika_czech from '../../../../../../assets/audio/jitika_czech.mp3';
import ida_norwegian from '../../../../../../assets/audio/ida_norwegian.mp3';
import hindi_kajal from '../../../../../../assets/audio/hindi_kajal.mp3';
import hindi_aditi from '../../../../../../assets/audio/hindi_aditi.mp3';
import hannah_german_austerian from '../../../../../../assets/audio/hannah_german_austerian.mp3';
import hala_arabic_gulf from '../../../../../../assets/audio/hala_arabic_gulf.mp3';
import emma_english_british from '../../../../../../assets/audio/emma_english_british.mp3';
import elin_swedish from '../../../../../../assets/audio/elin_swedish.mp3';
import daniel_german from '../../../../../../assets/audio/daniel_german.mp3';
import camila_portegues_brazillain from '../../../../../../assets/audio/camila_portegues_brazillain.mp3';
import burcu_turkish from '../../../../../../assets/audio/burcu_turkish.mp3';

import naja_danish from '../../../../../../assets/audio/naja_danish.mp3';
import mads_danish from '../../../../../../assets/audio/mads_danish.mp3';
import sofie_danish from '../../../../../../assets/audio/sofie_danish.mp3';

import suvi_finnish from '../../../../../../assets/audio/suvi_finnish.mp3';
import stephen_english_us from '../../../../../../assets/audio/stephen_english_us.mp3';

import salli_english_us from '../../../../../../assets/audio/salli_english_us.mp3';
import ruth_english_us from '../../../../../../assets/audio/ruth_english_us.mp3';
import russell_english_aus from '../../../../../../assets/audio/russell_english_aus.mp3';

import ruben_dutch from '../../../../../../assets/audio/ruben_dutch.mp3';
import raveena_english_indian from '../../../../../../assets/audio/raveena_english_indian.mp3';
import nicole_english_aus from '../../../../../../assets/audio/nicole_english_aus.mp3';

import matthew_english_us from '../../../../../../assets/audio/matthew_english_us.mp3';
import mathieu_french from '../../../../../../assets/audio/mathieu_french.mp3';
import marlene_german from '../../../../../../assets/audio/marlene_german.mp3';

import lotte_dutch from '../../../../../../assets/audio/lotte_dutch.mp3';
import liam_french_canadian from '../../../../../../assets/audio/liam_french_canadian.mp3';
import kimberly_english_us from '../../../../../../assets/audio/kimberly_english_us.mp3';

import kendra_english_us from '../../../../../../assets/audio/kendra_english_us.mp3';
import karl_icelandic from '../../../../../../assets/audio/karl_icelandic.mp3';
import joey_english_us from '../../../../../../assets/audio/joey_english_us.mp3';

import hans_germna from '../../../../../../assets/audio/hans_germna.mp3';
import joana_english_yus from '../../../../../../assets/audio/joana_english_yus.mp3';

import gregory_english_us from '../../../../../../assets/audio/gregory_english_us.mp3';
import giorgio_italian from '../../../../../../assets/audio/giorgio_italian.mp3';
import geraint_english_walsh from '../../../../../../assets/audio/geraint_english_walsh.mp3';

import gabrielle_french_canadian from '../../../../../../assets/audio/gabrielle_french_canadian.mp3';
import dora_iceandic from '../../../../../../assets/audio/dora_iceandic.mp3';
import danielle_english_us from '../../../../../../assets/audio/danielle_english_us.mp3';

import chantal_french_candian from '../../../../../../assets/audio/chantal_french_candian.mp3';
import celine_french from '../../../../../../assets/audio/celine_french.mp3';
import carla_italian from '../../../../../../assets/audio/carla_italian.mp3';
import aditi_english_indian from '../../../../../../assets/audio/aditi_english_indian.mp3';

import miguel_spanish_us from '../../../../../../assets/audio/miguel_spanish_us.mp3';
import penelope_spanish_us from '../../../../../../assets/audio/penelope_spanish_us.mp3';
import pedro_spanish_us from '../../../../../../assets/audio/pedro_spanish_us.mp3';
import mia_spanish_maxican from '../../../../../../assets/audio/mia_spanish_maxican.mp3';
import maxim_russian from '../../../../../../assets/audio/maxim_russian.mp3';
import maja_polish from '../../../../../../assets/audio/maja_polish.mp3';

import lupe_spanish_us from '../../../../../../assets/audio/lupe_spanish_us.mp3';
import jan_polish from '../../../../../../assets/audio/jan_polish.mp3';
import jacek_polish from '../../../../../../assets/audio/jacek_polish.mp3';

import astrid_sweedish from '../../../../../../assets/audio/astrid_sweedish.mp3';
import andres_spanish_mexican from '../../../../../../assets/audio/andres_spanish_mexican.mp3';
import carmen_romanian from '../../../../../../assets/audio/carmen_romanian.mp3';

import ewa_polish from '../../../../../../assets/audio/ewa_polish.mp3';
import tatyana_russian from '../../../../../../assets/audio/tatyana_russian.mp3';
import flizz_turksih from '../../../../../../assets/audio/flizz_turksih.mp3';
import gwyneth_walsh from '../../../../../../assets/audio/gwyneth_walsh.mp3';
import { Player, AudioPlayer } from './Player';
import {
  API_DEEPGRAM_TEXT_TO_SPPECH,
  gAPI_ElevenLabsVoices,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

function Features({ settings, saveIntegration }) {
  const [customAudioUrl, setCustomAudioUrl] = useState('');
  const [customTextChange, setCustomTextChange] = useState(true);

  const [voiceActors, setVoiceActors] = useState([
    {
      voice: 'Asteria',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-asteria-en',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'Deepgram',
    },
    {
      voice: 'Arcas',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-arcas-en',
      addCustomText: false,
      customText: '',
      audioFile: Arcas,
      provider: 'Deepgram',
    },
    {
      voice: 'Odysseus',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-odysseus-en',
      addCustomText: false,
      customText: '',
      audioFile: Odysseus,
      provider: 'Deepgram',
    },
    {
      voice: 'Thalia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-thalia-en',
      addCustomText: false,
      customText: '',
      audioFile: Thalia,
      provider: 'Deepgram',
    },
    {
      voice: 'Amalthea',
      accent: 'Filipino (US)',
      gender: 'F',
      values: 'aura-2-amalthea-en',
      addCustomText: false,
      customText: '',
      audioFile: Amalthea,
      provider: 'Deepgram',
    },
    {
      voice: 'Apollo',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-apollo-en',
      addCustomText: false,
      customText: '',
      audioFile: Apollo,
      provider: 'Deepgram',
    },
    {
      voice: 'Athena',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-athena-en',
      addCustomText: false,
      customText: '',
      audioFile: Athena,
      provider: 'Deepgram',
    },
    {
      voice: 'Atlas',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-atlas-en',
      addCustomText: false,
      customText: '',
      audioFile: Atlas,
      provider: 'Deepgram',
    },
    {
      voice: 'Aurora',
      accent: 'American  (US)',
      gender: 'F',
      values: 'aura-2-aurora-en',
      addCustomText: false,
      customText: '',
      audioFile: Aurora,
      provider: 'Deepgram',
    },
    {
      voice: 'Callista',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-callista-en',
      addCustomText: false,
      customText: '',
      audioFile: Callista,
      provider: 'Deepgram',
    },
    {
      voice: 'Cora',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-cora-en',
      addCustomText: false,
      customText: '',
      audioFile: Cora,
      provider: 'Deepgram',
    },
    {
      voice: 'Cordelia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-cordelia-en',
      addCustomText: false,
      customText: '',
      audioFile: Cordelia,
      provider: 'Deepgram',
    },
    {
      voice: 'Delia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-delia-en',
      addCustomText: false,
      customText: '',
      audioFile: Delia,
      provider: 'Deepgram',
    },
    {
      voice: 'Draco',
      accent: 'British (UK)',
      gender: 'M',
      values: 'aura-2-draco-en',
      addCustomText: false,
      customText: '',
      audioFile: Draco,
      provider: 'Deepgram',
    },
    {
      voice: 'Electra',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-electra-en',
      addCustomText: false,
      customText: '',
      audioFile: Electra,
      provider: 'Deepgram',
    },
    {
      voice: 'Harmonia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-harmonia-en',
      addCustomText: false,
      customText: '',
      audioFile: Harmonia,
      provider: 'Deepgram',
    },
    {
      voice: 'Helena',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-helena-en',
      addCustomText: false,
      customText: '',
      audioFile: Helena,
      provider: 'Deepgram',
    },
    {
      voice: 'Hera',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-hera-en',
      addCustomText: false,
      customText: '',
      audioFile: Hera,
      provider: 'Deepgram',
    },
    {
      voice: 'Hermes',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-hermes-en',
      addCustomText: false,
      customText: '',
      audioFile: Hermes,
      provider: 'Deepgram',
    },
    {
      voice: 'Hyperion',
      accent: 'Australian (AU)',
      gender: 'M',
      values: 'aura-2-hyperion-en',
      addCustomText: false,
      customText: '',
      audioFile: Hyperion,
      provider: 'Deepgram',
    },
    {
      voice: 'Iris',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-iris-en',
      addCustomText: false,
      customText: '',
      audioFile: Iris,
      provider: 'Deepgram',
    },
    {
      voice: 'Janus',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-janus-en',
      addCustomText: false,
      customText: '',
      audioFile: Janus,
      provider: 'Deepgram',
    },
    {
      voice: 'Juno',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-juno-en',
      addCustomText: false,
      customText: '',
      audioFile: Juno,
      provider: 'Deepgram',
    },
    {
      voice: 'Jupiter',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-jupiter-en',
      addCustomText: false,
      customText: '',
      audioFile: Jupiter,
      provider: 'Deepgram',
    },
    {
      voice: 'Luna',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-luna-en',
      addCustomText: false,
      customText: '',
      audioFile: Luna,
      provider: 'Deepgram',
    },
    {
      voice: 'Mars',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-mars-en',
      addCustomText: false,
      customText: '',
      audioFile: Mars,
      provider: 'Deepgram',
    },
    {
      voice: 'Minerva',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-minerva-en',
      addCustomText: false,
      customText: '',
      audioFile: Minerva,
      provider: 'Deepgram',
    },
    {
      voice: 'Neptune',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-neptune-en',
      addCustomText: false,
      customText: '',
      audioFile: Neptune,
      provider: 'Deepgram',
    },
    {
      voice: 'Ophelia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-ophelia-en',
      addCustomText: false,
      customText: '',
      audioFile: Ophelia,
      provider: 'Deepgram',
    },
    {
      voice: 'Orion',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-orion-en',
      addCustomText: false,
      customText: '',
      audioFile: Orion,
      provider: 'Deepgram',
    },
    {
      voice: 'Orpheus',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-orpheus-en',
      addCustomText: false,
      customText: '',
      audioFile: Orpheus,
      provider: 'Deepgram',
    },
    {
      voice: 'Pandora',
      accent: 'British (UK)',
      gender: 'F',
      values: 'aura-2-pandora-en',
      addCustomText: false,
      customText: '',
      audioFile: Pandora,
      provider: 'Deepgram',
    },
    {
      voice: 'Phoebe',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-phoebe-en',
      addCustomText: false,
      customText: '',
      audioFile: Phoebe,
      provider: 'Deepgram',
    },
    {
      voice: 'Pluto',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-pluto-en',
      addCustomText: false,
      customText: '',
      audioFile: Pluto,
      provider: 'Deepgram',
    },
    {
      voice: 'Saturn',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-saturn-en',
      addCustomText: false,
      customText: '',
      audioFile: Saturn,
      provider: 'Deepgram',
    },
    {
      voice: 'Selene',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-selene-en',
      addCustomText: false,
      customText: '',
      audioFile: Selene,
      provider: 'Deepgram',
    },
    {
      voice: 'Theia',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-theia-en',
      addCustomText: false,
      customText: '',
      audioFile: Theia,
      provider: 'Deepgram',
    },
    {
      voice: 'Vesta',
      accent: 'American (US)',
      gender: 'F',
      values: 'aura-2-vesta-en',
      addCustomText: false,
      customText: '',
      audioFile: Vesta,
      provider: 'Deepgram',
    },
    {
      voice: 'Zeus',
      accent: 'American (US)',
      gender: 'M',
      values: 'aura-2-zeus-en',
      addCustomText: false,
      customText: '',
      audioFile: Zeus,
      provider: 'Deepgram',
    },

    {
      voice: 'Zeina',
      accent: 'Arabic (arb)',
      gender: 'F',
      values: 'Zeina',
      addCustomText: false,
      customText: '',
      audioFile: zeina_arabic,
      provider: 'AWS',
    },
    {
      voice: 'Hala',
      accent: 'Arabic Gulf',
      gender: 'F',
      values: 'Hala',
      addCustomText: false,
      customText: '',
      audioFile: hala_arabic_gulf,
      provider: 'AWS',
    },
    {
      voice: 'Zayd',
      accent: 'Arabic Gulf',
      gender: 'M',
      values: 'Zayd',
      addCustomText: false,
      customText: '',
      audioFile: zayd_arabic_gulf,
      provider: 'AWS',
    },
    {
      voice: 'Lisa',
      accent: 'Dutch Belgian',
      gender: 'F',
      values: 'Lisa',
      addCustomText: false,
      customText: '',
      audioFile: lisa_dutch_beligan,
      provider: 'AWS',
    },
    {
      voice: 'Arlet',
      accent: 'Catalan',
      gender: 'F',
      values: 'Arlet',
      addCustomText: false,
      customText: '',
      audioFile: arlet_catalan,
      provider: 'AWS',
    },
    {
      voice: 'Jitka',
      accent: 'Czech',
      gender: 'F',
      values: 'Jitka',
      addCustomText: false,
      customText: '',
      audioFile: jitika_czech,
      provider: 'AWS',
    },
    {
      voice: 'Hiujin',
      accent: 'Chinese Cantonese',
      gender: 'F',
      values: 'Hiujin',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },
    {
      voice: 'Zhiyu',
      accent: 'Chinese Mandarin',
      gender: 'F',
      values: 'Zhiyu',
      addCustomText: false,
      customText: '',
      audioFile: zhiyu_chinese_mandarian,
      provider: 'AWS',
    },
    {
      voice: 'Naja',
      accent: 'Danish',
      gender: 'F',
      values: 'Naja',
      addCustomText: false,
      customText: '',
      audioFile: naja_danish,
      provider: 'AWS',
    },
    {
      voice: 'Sofie',
      accent: 'Danish',
      gender: 'F',
      values: 'Sofie',
      addCustomText: false,
      customText: '',
      audioFile: sofie_danish,
      provider: 'AWS',
    },
    {
      voice: 'Mads',
      accent: 'Danish',
      gender: 'M',
      values: 'Mads',
      addCustomText: false,
      customText: '',
      audioFile: mads_danish,
      provider: 'AWS',
    },
    {
      voice: 'Laura',
      accent: 'Dutch',
      gender: 'F',
      values: 'Laura',
      addCustomText: false,
      customText: '',
      audioFile: laura_danish,
      provider: 'AWS',
    },
    {
      voice: 'Lotte',
      accent: 'Dutch',
      gender: 'F',
      values: 'Lotte',
      addCustomText: false,
      customText: '',
      audioFile: lotte_dutch,
      provider: 'AWS',
    },
    {
      voice: 'Ruben',
      accent: 'Dutch',
      gender: 'M',
      values: 'Ruben',
      addCustomText: false,
      customText: '',
      audioFile: ruben_dutch,
      provider: 'AWS',
    },
    {
      voice: 'Nicole',
      accent: 'English Australian',
      gender: 'F',
      values: 'Nicole',
      addCustomText: false,
      customText: '',
      audioFile: nicole_english_aus,
      provider: 'AWS',
    },
    {
      voice: 'Olivia',
      accent: 'English Australian',
      gender: 'F',
      values: 'Olivia',
      addCustomText: false,
      customText: '',
      audioFile: olivia_english_aus,
      provider: 'AWS',
    },
    {
      voice: 'Russell',
      accent: 'English Australian',
      gender: 'M',
      values: 'Russell',
      addCustomText: false,
      customText: '',
      audioFile: russell_english_aus,
      provider: 'AWS',
    },

    {
      voice: 'Amy',
      accent: 'English British',
      gender: 'F',
      values: 'Amy',
      addCustomText: false,
      customText: '',
      audioFile: amy_english_british,
      provider: 'AWS',
    },
    {
      voice: 'Emma',
      accent: 'English British',
      gender: 'F',
      values: 'Emma',
      addCustomText: false,
      customText: '',
      audioFile: emma_english_british,
      provider: 'AWS',
    },
    {
      voice: 'Brian',
      accent: 'English British',
      gender: 'M',
      values: 'Brian',
      addCustomText: false,
      customText: '',
      audioFile: brian_english_british,
      provider: 'AWS',
    },
    {
      voice: 'Arthur',
      accent: 'English British',
      gender: 'M',
      values: 'Arthur',
      addCustomText: false,
      customText: '',
      audioFile: arthur_english_british,
      provider: 'AWS',
    },
    {
      voice: 'Kajal',
      accent: 'English Indian',
      gender: 'F',
      values: 'Kajal',
      addCustomText: false,
      customText: '',
      audioFile: kajal_english_indian,
      provider: 'AWS',
    },
    {
      voice: 'Raveena',
      accent: 'English Indian',
      gender: 'F',
      values: 'Raveena',
      addCustomText: false,
      customText: '',
      audioFile: raveena_english_indian,
      provider: 'AWS',
    },
    {
      voice: 'Aditi',
      accent: 'English Indian',
      gender: 'F',
      values: 'Aditi',
      addCustomText: false,
      customText: '',
      audioFile: aditi_english_indian,
      provider: 'AWS',
    },
    {
      voice: 'Niamh',
      accent: 'English Ireland',
      gender: 'F',
      values: 'Niamh',
      addCustomText: false,
      customText: '',
      audioFile: niamh_english_irish,
      provider: 'AWS',
    },
    {
      voice: 'Aria',
      accent: 'English New Zealand',
      gender: 'F',
      values: 'Aria',
      addCustomText: false,
      customText: '',
      audioFile: aria_english_newzeland,
      provider: 'AWS',
    },
    {
      voice: 'Ayanda',
      accent: 'English South African',
      gender: 'F',
      values: 'Ayanda',
      addCustomText: false,
      customText: '',
      audioFile: ayanda_english_south_africa,
      provider: 'AWS',
    },
    {
      voice: 'Geraint',
      accent: 'English Welsh',
      gender: 'M',
      values: 'Geraint',
      addCustomText: false,
      customText: '',
      audioFile: geraint_english_walsh,
      provider: 'AWS',
    },
    {
      voice: 'Suvi',
      accent: 'Finnish',
      gender: 'F',
      values: 'Suvi',
      addCustomText: false,
      customText: '',
      audioFile: suvi_finnish,
      provider: 'AWS',
    },

    {
      voice: 'Danielle',
      accent: 'English US',
      gender: 'F',
      values: 'Danielle',
      addCustomText: false,
      customText: '',
      audioFile: danielle_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Gregory',
      accent: 'English US',
      gender: 'M',
      values: 'Gregory',
      addCustomText: false,
      customText: '',
      audioFile: gregory_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Joanna',
      accent: 'English US',
      gender: 'F',
      values: 'Joanna',
      addCustomText: false,
      customText: '',
      audioFile: joana_english_yus,
      provider: 'AWS',
    },
    {
      voice: 'Kendra',
      accent: 'English US',
      gender: 'F',
      values: 'Kendra',
      addCustomText: false,
      customText: '',
      audioFile: kendra_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Kimberly',
      accent: 'English US',
      gender: 'F',
      values: 'Kimberly',
      addCustomText: false,
      customText: '',
      audioFile: kimberly_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Salli',
      accent: 'English US',
      gender: 'F',
      values: 'Salli',
      addCustomText: false,
      customText: '',
      audioFile: salli_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Joey',
      accent: 'English US',
      gender: 'M',
      values: 'Joey',
      addCustomText: false,
      customText: '',
      audioFile: joey_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Matthew',
      accent: 'English US',
      gender: 'M',
      values: 'Matthew',
      addCustomText: false,
      customText: '',
      audioFile: matthew_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Ruth',
      accent: 'English US',
      gender: 'F',
      values: 'Ruth',
      addCustomText: false,
      customText: '',
      audioFile: ruth_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Stephen',
      accent: 'English US',
      gender: 'M',
      values: 'Stephen',
      addCustomText: false,
      customText: '',
      audioFile: stephen_english_us,
      provider: 'AWS',
    },
    {
      voice: 'Patrick',
      accent: 'English US',
      gender: 'M',
      values: 'Patrick',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Céline/Celine',
      accent: 'French',
      gender: 'F',
      values: 'Céline/Celine',
      addCustomText: false,
      customText: '',
      audioFile: celine_french,
      provider: 'AWS',
    },
    {
      voice: 'Léa',
      accent: 'French',
      gender: 'F',
      values: 'Léa',
      addCustomText: false,
      customText: '',
      audioFile: lea_french,
      provider: 'AWS',
    },
    {
      voice: 'Mathieu',
      accent: 'French',
      gender: 'M',
      values: 'Mathieu',
      addCustomText: false,
      customText: '',
      audioFile: mathieu_french,
      provider: 'AWS',
    },
    {
      voice: 'Rémi',
      accent: 'French',
      gender: 'M',
      values: 'Rémi',
      addCustomText: false,
      customText: '',
      audioFile: remi_french,
      provider: 'AWS',
    },

    {
      voice: 'Isabelle',
      accent: 'French Belgian',
      gender: 'F',
      values: 'Isabelle',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },
    {
      voice: 'Chantal',
      accent: 'French Canadian',
      gender: 'F',
      values: 'Chantal',
      addCustomText: false,
      customText: '',
      audioFile: chantal_french_candian,
      provider: 'AWS',
    },
    {
      voice: 'Gabrielle',
      accent: 'French Canadian',
      gender: 'F',
      values: 'Gabrielle',
      addCustomText: false,
      customText: '',
      audioFile: gabrielle_french_canadian,
      provider: 'AWS',
    },
    {
      voice: 'Liam',
      accent: 'French Canadian',
      gender: 'F',
      values: 'Liam',
      addCustomText: false,
      customText: '',
      audioFile: liam_french_canadian,
      provider: 'AWS',
    },

    {
      voice: 'Hans',
      accent: 'German',
      gender: 'M',
      values: 'Hans',
      addCustomText: false,
      customText: '',
      audioFile: hans_germna,
      provider: 'AWS',
    },

    {
      voice: 'Daniel',
      accent: 'German',
      gender: 'M',
      values: 'Daniel',
      addCustomText: false,
      customText: '',
      audioFile: daniel_german,
      provider: 'AWS',
    },
    {
      voice: 'Vicki',
      accent: 'German',
      gender: 'F',
      values: 'Vicki',
      addCustomText: false,
      customText: '',
      audioFile: vicki_german,
      provider: 'AWS',
    },
    {
      voice: 'Marlene',
      accent: 'German',
      gender: 'F',
      values: 'Marlene',
      addCustomText: false,
      customText: '',
      audioFile: marlene_german,
      provider: 'AWS',
    },

    {
      voice: 'Hannah',
      accent: 'German Austrian',
      gender: 'F',
      values: 'Hannah',
      addCustomText: false,
      customText: '',
      audioFile: hannah_german_austerian,
      provider: 'AWS',
    },

    {
      voice: 'Sabrina',
      accent: 'German Swiss',
      gender: 'F',
      values: 'Sabrina',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },
    {
      voice: 'Kajal',
      accent: 'Hindi',
      gender: 'F',
      values: 'Kajal',
      addCustomText: false,
      customText: '',
      audioFile: hindi_kajal,
      provider: 'AWS',
    },
    {
      voice: 'Aditi',
      accent: 'Hindi',
      gender: 'F',
      values: 'Aditi',
      addCustomText: false,
      customText: '',
      audioFile: hindi_aditi,
      provider: 'AWS',
    },
    {
      voice: 'Dóra/Dora',
      accent: 'Icelandic',
      gender: 'F',
      values: 'Dóra/Dora',
      addCustomText: false,
      customText: '',
      audioFile: dora_iceandic,
      provider: 'AWS',
    },
    {
      voice: 'Karl',
      accent: 'Icelandic',
      gender: 'M',
      values: 'Karl',
      addCustomText: false,
      customText: '',
      audioFile: karl_icelandic,
      provider: 'AWS',
    },

    {
      voice: 'Carla',
      accent: 'Italian',
      gender: 'F',
      values: 'Carla',
      addCustomText: false,
      customText: '',
      audioFile: carla_italian,
      provider: 'AWS',
    },

    {
      voice: 'Adriano',
      accent: 'Italian',
      gender: 'M',
      values: 'Adriano',
      addCustomText: false,
      customText: '',
      audioFile: adriano_italian,
      provider: 'AWS',
    },

    {
      voice: 'Giorgio',
      accent: 'Italian',
      gender: 'M',
      values: 'Giorgio',
      addCustomText: false,
      customText: '',
      audioFile: giorgio_italian,
      provider: 'AWS',
    },

    {
      voice: 'Bianca',
      accent: 'Italian',
      gender: 'F',
      values: 'Bianca',
      addCustomText: false,
      customText: '',
      audioFile: bianca_italian,
      provider: 'AWS',
    },

    {
      voice: 'Takumi',
      accent: 'Japanese',
      gender: 'M',
      values: 'Takumi',
      addCustomText: false,
      customText: '',
      audioFile: takumi_japneese,
      provider: 'AWS',
    },
    {
      voice: 'Mizuki',
      accent: 'Japanese',
      gender: 'F',
      values: 'Mizuki',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },
    {
      voice: 'Seoyeon',
      accent: 'Korean',
      gender: 'F',
      values: 'Seoyeon',
      addCustomText: false,
      customText: '',
      audioFile: seoyeon_korean,
      provider: 'AWS',
    },
    {
      voice: 'Liv',
      accent: 'Norwegian',
      gender: 'F',
      values: 'Liv',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Ida',
      accent: 'Norwegian',
      gender: 'F',
      values: 'Ida',
      addCustomText: false,
      customText: '',
      audioFile: ida_norwegian,
      provider: 'AWS',
    },
    {
      voice: 'Ewa',
      accent: 'Polish',
      gender: 'F',
      values: 'Ewa',
      addCustomText: false,
      customText: '',
      audioFile: ewa_polish,
      provider: 'AWS',
    },
    {
      voice: 'Maja',
      accent: 'Polish',
      gender: 'F',
      values: 'Maja',
      addCustomText: false,
      customText: '',
      audioFile: maja_polish,
      provider: 'AWS',
    },
    {
      voice: 'Jacek',
      accent: 'Polish',
      gender: 'M',
      values: 'Jacek',
      addCustomText: false,
      customText: '',
      audioFile: jacek_polish,
      provider: 'AWS',
    },
    {
      voice: 'Jan',
      accent: 'Polish',
      gender: 'M',
      values: 'Jan',
      addCustomText: false,
      customText: '',
      audioFile: jan_polish,
      provider: 'AWS',
    },
    {
      voice: 'Ola',
      accent: 'Polish',
      gender: 'F',
      values: 'Ola',
      addCustomText: false,
      customText: '',
      audioFile: ola_polish,
      provider: 'AWS',
    },

    {
      voice: 'Camila',
      accent: 'Portuguese Brazilian',
      gender: 'F',
      values: 'Camila',
      addCustomText: false,
      customText: '',
      audioFile: camila_portegues_brazillain,
      provider: 'AWS',
    },

    {
      voice: 'Vitória/Vitoria',
      accent: 'Portuguese Brazilian',
      gender: 'F',
      values: 'Vitória/Vitoria',
      addCustomText: false,
      customText: '',
      audioFile: vitoria_portegues_brazillain,
      provider: 'AWS',
    },

    {
      voice: 'Ricardo',
      accent: 'Portuguese Brazilian',
      gender: 'M',
      values: 'Ricardo',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Thiago',
      accent: 'Portuguese Brazilian',
      gender: 'M',
      values: 'Thiago',
      addCustomText: false,
      customText: '',
      audioFile: thiago_portegues_brazillain,
      provider: 'AWS',
    },

    {
      voice: 'Camila',
      accent: 'Portuguese European',
      gender: 'F',
      values: 'Camila',
      addCustomText: false,
      customText: '',
      audioFile: camila_portegues_brazillain,
      provider: 'AWS',
    },

    {
      voice: 'Cristiano',
      accent: 'Portuguese European',
      gender: 'M',
      values: 'Cristiano',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Tatyana',
      accent: 'Russian',
      gender: 'F',
      values: 'Tatyana',
      addCustomText: false,
      customText: '',
      audioFile: tatyana_russian,
      provider: 'AWS',
    },
    {
      voice: 'Carmen',
      accent: 'Romanian',
      gender: 'F',
      values: 'Carmen',
      addCustomText: false,
      customText: '',
      audioFile: carmen_romanian,
      provider: 'AWS',
    },
    {
      voice: 'Maxim',
      accent: 'Russian',
      gender: 'M',
      values: 'Maxim',
      addCustomText: false,
      customText: '',
      audioFile: maxim_russian,
      provider: 'AWS',
    },

    {
      voice: 'Conchita',
      accent: 'Spanish Spain',
      gender: 'F',
      values: 'Conchita',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Lucia',
      accent: 'Spanish Spain',
      gender: 'F',
      values: 'Lucia',
      addCustomText: false,
      customText: '',
      audioFile: lucia_spanish_castilian,
      provider: 'AWS',
    },

    {
      voice: 'Alba',
      accent: 'Spanish Spain',
      gender: 'F',
      values: 'Alba',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Enrique',
      accent: 'Spanish Spain',
      gender: 'M',
      values: 'Enrique',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Sergio',
      accent: 'Spanish Spain',
      gender: 'M',
      values: 'Sergio',
      addCustomText: false,
      customText: '',
      audioFile: sergio_spanish_castilian,
      provider: 'AWS',
    },

    {
      voice: 'Raúl',
      accent: 'Spanish Spain',
      gender: 'M',
      values: 'Raúl',
      addCustomText: false,
      customText: '',
      audioFile: Asteria,
      provider: 'AWS',
    },

    {
      voice: 'Mia',
      accent: 'Spanish Mexican',
      gender: 'F',
      values: 'Mia',
      addCustomText: false,
      customText: '',
      audioFile: mia_spanish_maxican,
      provider: 'AWS',
    },

    {
      voice: 'Andrés',
      accent: 'Spanish Mexican',
      gender: 'M',
      values: 'Andrés',
      addCustomText: false,
      customText: '',
      audioFile: andres_spanish_mexican,
      provider: 'AWS',
    },

    {
      voice: 'Lupe',
      accent: 'Spanish US',
      gender: 'F',
      values: 'Lupe',
      addCustomText: false,
      customText: '',
      audioFile: lupe_spanish_us,
      provider: 'AWS',
    },

    {
      voice: 'Penélope/Penelope',
      accent: 'Spanish US',
      gender: 'F',
      values: 'Penélope/Penelope',
      addCustomText: false,
      customText: '',
      audioFile: penelope_spanish_us,
      provider: 'AWS',
    },

    {
      voice: 'Miguel',
      accent: 'Spanish US',
      gender: 'M',
      values: 'Miguel',
      addCustomText: false,
      customText: '',
      audioFile: miguel_spanish_us,
      provider: 'AWS',
    },

    {
      voice: 'Pedro',
      accent: 'Spanish US',
      gender: 'M',
      values: 'Pedro',
      addCustomText: false,
      customText: '',
      audioFile: pedro_spanish_us,
      provider: 'AWS',
    },

    {
      voice: 'Astrid',
      accent: 'Swedish',
      gender: 'F',
      values: 'Astrid',
      addCustomText: false,
      customText: '',
      audioFile: astrid_sweedish,
      provider: 'AWS',
    },

    {
      voice: 'Elin',
      accent: 'Swedish',
      gender: 'F',
      values: 'Elin',
      addCustomText: false,
      customText: '',
      audioFile: elin_swedish,
      provider: 'AWS',
    },

    {
      voice: 'Filiz',
      accent: 'Turkish',
      gender: 'F',
      values: 'Filiz',
      addCustomText: false,
      customText: '',
      audioFile: flizz_turksih,
      provider: 'AWS',
    },

    {
      voice: 'Burcu',
      accent: 'Turkish',
      gender: 'F',
      values: 'Burcu',
      addCustomText: false,
      customText: '',
      audioFile: burcu_turkish,
      provider: 'AWS',
    },

    {
      voice: 'Gwyneth',
      accent: 'Welsh',
      gender: 'F',
      values: 'Gwyneth',
      addCustomText: false,
      customText: '',
      audioFile: gwyneth_walsh,
      provider: 'AWS',
    },
  ]);

  const initialVoiceActorsRef = useRef([]);
  useEffect(() => {
    initialVoiceActorsRef.current = voiceActors;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [smsSettings, setSMSSettings] = useState(
    settings?.smsSettings || {
      smsNumber: '',
      bulkSMS: false,
      syncSMS: false,
      individualSMS: false,
    }
  );

  const [features, setFeatures] = useState({
    recording: false,
    transcribe: false,
    voiceActor: 'aura-asteria-en',
    autoLanguageDetection: false,
    realTimeStreaming: false,
    provider: '',
    voiceProcessing: 'Normal',
    agentId: '',
  });
  useEffect(() => {
    if (settings !== undefined && settings.features !== undefined) {
      setFeatures({
        recording: settings.features.recording,
        transcribe: settings.features.transcribe,
        voiceActor: settings.features.voiceActor,
        autoLanguageDetection: settings.features.autoLanguageDetection,
        realTimeStreaming: settings.features.realTimeStreaming,
        provider: settings.features?.provider || '',
        humanAssistant: settings.features.humanAssistant || false,
        ES6Format: settings.features.ES6Format || '',
        voiceProcessing: settings.features.voiceProcessing,
        agentId: settings.features.agentId || '',
      });
    }
  }, [settings]);
  useEffect(() => {
    const loadElevenVoices = async () => {
      try {
        const res = await AxiosAPI({
          method: 'get',
          url: gAPI_ElevenLabsVoices,
        });
        let list = res?.data?.voices || res?.data || [];
        if (!Array.isArray(list)) list = [];
        const mapped = list.map((v) => ({
          voice: v.name,
          accent: v.labels.accent || '',
          gender: v.labels.gender || '',
          values: v.voice_id,
          addCustomText: false,
          customText: '',
          audioFile: null,
          provider: 'ElevenLabs',
          verified_languages: v.verified_languages
            ? [
                ...new Map(
                  v.verified_languages.map((item) => [item.preview_url, item])
                ).values(),
              ]
            : [],
        }));
        console.log('ElevenLabs voices loaded:', mapped);
        if (mapped.length > 0) {
          setVoiceActors(mapped);
          setFeatures((prev) => ({
            ...prev,
            voiceActor:
              prev.voiceActor &&
              mapped.find((m) => m.values === prev.voiceActor)
                ? prev.voiceActor
                : mapped[0].values,
            provider: 'ElevenLabs',
          }));
        } else {
          NotificationManager.info(
            'No voices returned from ElevenLabs',
            '',
            3000
          );
        }
      } catch (err) {
        NotificationManager.warning(
          'Failed to load ElevenLabs voices',
          '',
          3000
        );
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    if (features?.voiceProcessing === 'ElevenLabs') {
      loadElevenVoices();
    } else {
      if (
        initialVoiceActorsRef.current &&
        initialVoiceActorsRef.current.length > 0
      ) {
        setVoiceActors(initialVoiceActorsRef.current);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features?.voiceProcessing]);
  const handleRecording = (e) => {
    setFeatures({ ...features, recording: e });
  };
  const handleTranscribe = (e) => {
    setFeatures({ ...features, transcribe: e });
  };
  const handleAgentId = (e) => {
    console.log(e.target.value);
    setFeatures({ ...features, agentId: e.target.value });
  };
  const handleVoiceProcessing = (e, value) => {
    // determine original voice id from initialVoiceActorsRef to restore mapping
    let originalVoiceId = '';
    try {
      const currentActor = voiceActors.find(
        (v) => v.values == features.voiceActor
      );
      if (currentActor) {
        const orig = initialVoiceActorsRef.current.find(
          (o) =>
            o.voice === currentActor.voice || o.values === currentActor.values
        );
        if (orig) originalVoiceId = orig.values;
      }
    } catch (err) {
      // ignore and fallback
    }
    if (!originalVoiceId && initialVoiceActorsRef.current.length > 0) {
      originalVoiceId = initialVoiceActorsRef.current[0].values;
    }

    const providerForOriginal =
      (
        initialVoiceActorsRef.current.find(
          (o) => o.values === originalVoiceId
        ) || {}
      ).provider || features.provider;

    if (value === 'Realtime' && e === true) {
      setFeatures({
        ...features,
        voiceProcessing: 'Realtime',
        voiceActor: originalVoiceId,
        provider: providerForOriginal,
      });
    } else if (value === 'Normal' && e === true) {
      setFeatures({
        ...features,
        voiceProcessing: 'Normal',
        voiceActor: originalVoiceId,
        provider: providerForOriginal,
      });
    } else if (value === 'ElevenLabs' && e === true) {
      setFeatures({
        ...features,
        voiceProcessing: 'ElevenLabs',
        voiceActor: originalVoiceId,
        provider: 'ElevenLabs',
      });
    } else if (value === 'Realtime' && e === false) {
      setFeatures({
        ...features,
        voiceProcessing: 'Normal',
        voiceActor: originalVoiceId,
        provider: providerForOriginal,
      });
    } else if (value === 'Normal' && e === false) {
      setFeatures({
        ...features,
        voiceProcessing: 'Realtime',
        voiceActor: originalVoiceId,
        provider: providerForOriginal,
      });
    } else if (value === 'ElevenLabs' && e === false) {
      setFeatures({
        ...features,
        voiceProcessing: 'Realtime',
        voiceActor: originalVoiceId,
        provider: providerForOriginal,
      });
    }
  };
  const handleVoiceActor = (e) => {
    let lst = [...voiceActors];
    if (lst.filter((f) => f.values == e.target.value).length > 0) {
      setFeatures({
        ...features,
        voiceActor: e.target.value,
        provider: lst.filter((f) => f.values == e.target.value)[0].provider,
      });
    } else {
      setFeatures({ ...features, voiceActor: e.target.value });
    }
  };

  const handleStreaming = (e) => {
    setFeatures({ ...features, realTimeStreaming: e });
  };

  const addCustomText = (e) => {
    let lst = [...voiceActors];
    if (lst.filter((f) => f.values == features.voiceActor).length > 0) {
      lst.filter((f) => f.values == features.voiceActor)[0].addCustomText = e;
    }
    setVoiceActors(lst);
  };
  const handleCustomText = (e) => {
    setCustomTextChange(true);
    let lst = [...voiceActors];
    if (lst.filter((f) => f.values == features.voiceActor).length > 0) {
      lst.filter((f) => f.values == features.voiceActor)[0].customText =
        e.target.value;
    }
    setVoiceActors(lst);
  };

  const handleSave = () => {
    saveIntegration({ features: features, smsSettings: smsSettings });
  };

  const customTextAudio = () => {
    let lst = [...voiceActors];
    if (lst.filter((f) => f.values == features.voiceActor).length > 0) {
      let body = {
        text: lst.filter((f) => f.values == features.voiceActor)[0].customText,
        voiceActor: features.voiceActor,
      };
      AxiosAPI({
        method: 'post',
        url: `${API_DEEPGRAM_TEXT_TO_SPPECH}`,
        data: body,
      })
        .then((res) => {
          if (res.data.status !== undefined) {
            const blob = new Blob([res.data.status], { type: 'audio/wav' });
            const audio = URL.createObjectURL(blob);
            setCustomAudioUrl(res.data.status);
            setCustomTextChange(false);
          }
        })
        .catch((err) => console.log('err', err));
    }
  };

  const selectedActor =
    voiceActors.find((f) => f.values === features.voiceActor) || undefined;

  const handleSMSNumber = (e) => {
    setSMSSettings({ ...smsSettings, smsNumber: e.target.value });
  };

  const handleIndividualSMS = (e) => {
    setSMSSettings({ ...smsSettings, individualSMS: e });
  };
  const handleSynsSMS = (e) => {
    setSMSSettings({ ...smsSettings, syncSMS: e });
  };
  const handleBulkSMS = (e) => {
    setSMSSettings({ ...smsSettings, bulkSMS: e });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Features</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Recording</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={features?.recording}
                name="recording"
                onChange={(e) => handleRecording(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                When enabled, the AI part of the voice call will be recorded
              </p>
            </div>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Transcribe</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={features?.transcribe}
                name="transcribe"
                onChange={(e) => handleTranscribe(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                When enabled, the recording is transcribed using a Speech to
                Text (STT) Service
              </p>
            </div>
          </div>
          <Separator className="mb-3" />
          <div className=" mb-3 ml-2">
            <h5 style={{ marginTop: '0.15rem' }}>Voice Processing</h5>
          </div>

          {/* <Separator className="mb-3" /> */}
          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>
                Speech to Text & Text to Speech
              </h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={features?.voiceProcessing === 'Normal' ? true : false}
                name="voiceProcessing"
                onChange={(e) => handleVoiceProcessing(e, 'Normal')}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                More control, more choices of voice actors, and cost effective
              </p>
            </div>
          </div>

          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Real Time Streaming</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={
                  features?.voiceProcessing === 'Realtime' ? true : false
                }
                name="voiceProcessing"
                onChange={(e) => handleVoiceProcessing(e, 'Realtime')}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                Less choices of voice actors,but the fastest model for
                processing voice
              </p>
            </div>
          </div>

          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Multi-Lingual Agent</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={
                  features?.voiceProcessing === 'ElevenLabs' ? true : false
                }
                name="voiceProcessing"
                onChange={(e) => handleVoiceProcessing(e, 'ElevenLabs')}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                Agent which supports multiple languages with the fastest model
                for processing voice
              </p>
            </div>
          </div>

          {features?.voiceProcessing === 'ElevenLabs' && (
            <div className="row mt-1 ml-2 mb-1">
              <div className="d-flex w-100">
                <h5 style={{ marginTop: '0.15rem' }}>Agent Id</h5>
              </div>
              <div className="row " style={{ marginLeft: '-0.5rem' }}>
                <Input
                  type="text"
                  disabled={true}
                  style={{ width: '100%', marginTop: '0.5rem' }}
                  value={features?.agentId || ''}
                  onChange={handleAgentId}
                  placeholder="Enter AgentId"
                />
              </div>
            </div>
          )}
          {/* <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>
                Realtime Streaming (Coming Soon!)
              </h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2 mt-1"
                checked={features?.realTimeStreaming}
                name="streaming"
                onChange={(e) => handleStreaming(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                Intercepts and injects live audio for real-time audio
                processing, allowing for AI-driven live dashboards on contact
                centre performance and analysis.
              </p>
            </div>
          </div> */}
          <Separator className="mb-3 d-none" />
          <div className="row mt-1 ml-2 mb-1 d-none">
            <div className="w-100">
              <h5 style={{ marginTop: '0.15rem' }}>SMS Number</h5>
              <p>Type Number With Country Code</p>
              <Input
                type="text"
                value={smsSettings.smsNumber}
                onChange={handleSMSNumber}
                className="mb-2"
                style={{ width: '50%' }}
                placeholder="SMS Number"
              ></Input>
            </div>
          </div>
          <div className="row mt-1 ml-2 mb-1 d-none">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Individual SMS sending</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={smsSettings?.individualSMS}
                name="recording"
                onChange={(e) => handleIndividualSMS(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                When enabled, you can send messages to customers one at a time
              </p>
            </div>
          </div>
          <Separator className="mb-3 d-none" />
          <div className="row mt-1 ml-2 mb-1 d-none">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Sync SMS response</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={smsSettings?.syncSMS}
                name="transcribe"
                onChange={(e) => handleSynsSMS(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">
                When enabled, the response to a message will be pulled into the
                dashoard
              </p>
            </div>
          </div>
          <Separator className="mb-3 d-none" />
          <div className="row mt-1 ml-2 mb-1 d-none">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Bulk SMS sending</h5>
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2"
                checked={smsSettings?.bulkSMS}
                name="transcribe"
                onChange={(e) => handleBulkSMS(e)}
              />
            </div>
            <div className="row " style={{ marginLeft: '-0.5rem' }}>
              <p className="m-2">Coming Soon</p>
            </div>
          </div>
          <Separator className="my-2 d-none"></Separator>
          <div className="d-flex justify-content-center mt-1 ml-2 mb-1">
            <div className="mb-2" style={{ marginTop: '20px' }}>
              <Button color="primary" size="xs" onClick={handleSave}>
                Save
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}
export default Features;

// --- SMS Settings UI and logic appended below ---
// (Already integrated above in the Features component)
